export function openTest(
    dispatch,
    history,
    file,
    handleGetTikets,
    noteData,
    canDoIt,
    fromCourse,
    notes
) {
    let testData = {
        test_id: file.test_id,
        test_name: file.test_name,
        test_content: JSON.parse(file.test_content),
        test_prompt: file.test_prompt,
        icon: file.icon,
        note_id: {
            note_id: file.note_id.note_id,
        },
        no_of_questions: file.no_of_questions,
        test_type: file.test_type,
    };
    dispatch(handleGetTikets(JSON.stringify(testData)));
    let array = JSON.parse(file.test_content);
    let note_id = file.note_id.note_id;
    let test_id = file.test_id;
    let testType = file.test_type;
    let isData = true;
  
    history.push({
        pathname: "/accountingTest",
        state: {
            array,
            testType,
            note_id,
            isData,
            test_id,
            noteData,
            canDoIt,
            fromCourse,
            notes,
        },
    });
}
